import React from 'react';

let Footer = () => {
    return (
        <footer className='py-0 footer'>
            <div className=''>
                <p className=' text-left'>
                    Copyright &copy; Vizomenu 2025
                </p>
            </div>
        </footer>
    );
}
export default Footer;